const styles = (theme) => ({
  imageListContainer: {
    flex: 0.5,
  },
  imageContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  loadingLabel: {
    fontSize: theme.textFontSize,
    color: theme.HeaderSelectedText,
  },
  imageGroupTitle: {
    fontSize: 20,
    color: theme.HeaderSelectedText,
  },
  dialogWrapper: {
    height: "100%"
  },
  dialog: {
    backgroundColor: theme.ModalBGColor,
    height: "70%",
    width: "50%",
    minHeight: 600,
    minWidth: 900,
  },
  dialogContent: {
    display: "flex",
    padding : 24,
    height: "80%"
  },
  listSubHeader: {
    fontSize: theme.headerTextFontSize,
    lineHeight: "16px",
    cursor: "default",
    padding: "0px 8px 8px 8px",
    color: theme.TextColor,
    fontWeight: 600,
    textTransform : "uppercase",
    position : "relative"
  },
  listItem: {
    fontSize: theme.headerTextFontSize,
    cursor: "pointer",
    color: theme.ColumnHeaderTextColor,
    textTransform: "capitalize",
    padding: "8px 20px",
    "&$listItemSelected, &$listItemSelected:hover, &$listItemSelected:focus": {
      backgroundColor: theme.HeaderSelectedText,
    },
    display: "flex",
    justifyContent: "space-between",
    minWidth: 180,
  },
  listItemSelected: {
    backgroundColor: theme.HeaderSelectedText,
    color: theme.white,
  },
  closeButtonContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "4px 8px 8px 32px",
    alignItems: "center",
    borderBottom: `1px solid ${theme.AppBGColor}`,
  },
  imagesContainer: {
    flex: 1,
    paddingLeft: 24,
    paddingBottom: 24,
    overflow: "auto",
  },
  closeButton: {
    color: theme.iconColor,
  },
  refreshButton: {
    marginRight: 4,
    "& span": {
      marginLeft: 4,
    },
  },
  center: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  error: {
    color: theme.error,
  },
  message: {
    color: theme.iconColor,
  },
  dropDownContainer: {
    display: "flex",
    alignItems: "center",
    width: "70%",
  },
  headerText: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    minWidth: 100,
  },
  dropdownInput: {
    padding: "4px 0px",
  },
  eDRPlaceholderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 150,
    width: 120,
    cursor: "pointer",
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: "2px",
  },
  descriptionIcon : {
    color : theme.iconColor
  },
  label : {
    color: theme.gridTextColor,
    textTransform: "capitalize",
    margin: "12px 0",
  },
  edrContainer:{
    display:"flex",
    width:"100%",
    flexWrap: "wrap"
  },
  edRBox:{
    padding:"0px 5px 10px 5px"
  },
  actionIcon: {
    padding: '6px',
    cursor: 'pointer',
    color: theme.iconColor,
    fontSize:theme.textFontSize
  },
  edrActions: {
    position: 'absolute',
    top: 0,
    right: 0,
    display: 'flex',
    padding: '6px'
  },
  circularProgress: {
    color: theme.iconColor
  },
});

export default styles;